import { useMemo } from 'react';

import {
    assertTradingAuthorityForRequest,
    handleTradingAuthorityRequired,
} from '@/features/tradingSession/clientAuthority';
import {
    createWolfswapAuthedApi,
    createWolfswapFactionsAuthedApi,
} from '@/lib/api/clients/wolfswap';

import { useAuth } from './useAuth';

/**
 * MoonHub application-token client. Every known RustSigner-backed mutation is
 * preflighted through the central trading-authority store, and a server-side
 * 428 opens the same reauthentication flow without dropping the app token.
 */
export function useAuthedApi() {
    const { token, clearLocalSession } = useAuth();

    return useMemo(() => {
        if (!token) return null;
        const tokenRef = token;
        return createWolfswapAuthedApi(() => tokenRef, clearLocalSession, {
            beforeSignerMutation: assertTradingAuthorityForRequest,
            onTradingAuthorityRequired: handleTradingAuthorityRequired,
        });
    }, [token, clearLocalSession]);
}

/**
 * Read-only factions client. It receives the same public-key-verifiable app
 * token, sends no cookies, and never receives signer/passkey authority.
 */
export function useFactionsAuthedApi() {
    const { token, clearLocalSession } = useAuth();

    return useMemo(() => {
        if (!token) return null;
        const tokenRef = token;
        return createWolfswapFactionsAuthedApi(
            () => tokenRef,
            clearLocalSession,
        );
    }, [token, clearLocalSession]);
}
